import React from 'react'

// import './Header.css'
export default function Header() {
  return (
    <>
      {/* <div className="header">
      <p>Free Shipping | Payment Plans Available At Checkout!</p> 
    </div> */}
  
    </>
  )
}
